import * as React from "react";

const PackageIcon: React.FC<{ className?: string }> = ({ className }) => (
  <svg
    className={className}
    height="1.1em"
    width="1em"
    viewBox="0 0 21 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.9127 3.45361H2.34749C1.43493 3.45361 0.695312 4.16212 0.695312 5.03695V17.0369C0.695312 17.9118 1.43493 18.6203 2.34749 18.6203H19.0431C19.9557 18.6203 20.6953 17.9118 20.6953 17.0369V5.03695C20.6953 4.16212 19.9557 3.45361 19.0431 3.45361H15.4779V3.03695C15.4779 1.61007 14.2711 0.453613 12.7823 0.453613H8.60836C7.11953 0.453613 5.9127 1.61007 5.9127 3.03695V3.45361ZM14.2605 3.45361H7.1301V3.03695C7.1301 2.25491 7.79183 1.62028 8.60836 1.62028H12.7823C13.5988 1.62028 14.2605 2.25491 14.2605 3.03695V3.45361ZM19.4779 17.4536H1.9127V8.62028H5.9127V10.6203H9.21705V8.62028H12.1736V10.6203H15.4779V8.62028H19.4779V17.4536Z"
      fill="currentColor"
    />
  </svg>
);

export const OpenPackageIcon: React.FC<{ className?: string }> = ({ className }) => (
  <svg
    className={className}
    data-testid="open-package-icon"
    width="28"
    height="28"
    viewBox="0 0 35 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M18.5 28.206V16.1914" stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18.5011 3.49219C17.9264 3.49219 17.3619 3.64327 16.864 3.93028L16.8622 3.93133L8.52222 8.69702L8.51877 8.69901C8.02098 8.98641 7.60752 9.39966 7.31986 9.8973C7.03221 10.3949 6.88047 10.9595 6.87988 11.5343V21.0715C6.88047 21.6463 7.03221 22.2108 7.31986 22.7085C7.60752 23.2061 8.02098 23.6194 8.51877 23.9068L8.52222 23.9087L16.8622 28.6744L16.8641 28.6755C17.3619 28.9625 17.9265 29.1136 18.5011 29.1136C19.0757 29.1136 19.6403 28.9625 20.1381 28.6755L20.14 28.6744L28.48 23.9087L28.4834 23.9068C28.9812 23.6194 29.3947 23.2061 29.6824 22.7085C29.97 22.2108 30.1217 21.6463 30.1223 21.0715L30.1223 11.5352L30.1223 11.5343C30.1217 10.9595 29.97 10.3949 29.6824 9.8973C29.3947 9.39966 28.9812 8.98641 28.4834 8.699L20.14 3.93133L20.1382 3.93028C19.6403 3.64327 19.0758 3.49219 18.5011 3.49219ZM18.0083 5.36392C18.1661 5.30864 18.3326 5.28007 18.5011 5.28007L18.5185 5.30807C18.5276 5.30814 18.5367 5.30827 18.5457 5.30846L18.5011 5.28007C18.6696 5.28007 18.8361 5.30863 18.9938 5.36391C19.206 5.41268 19.4107 5.49289 19.6008 5.60266L27.2985 10.0014C27.4778 10.1049 27.6407 10.2327 27.7831 10.3805C27.9239 10.4947 28.0431 10.634 28.1345 10.792C28.2286 10.955 28.2908 11.1336 28.3182 11.3185C28.3709 11.5083 28.398 11.7051 28.3982 11.9038V20.7012C28.398 20.8995 28.3709 21.0961 28.3185 21.2856C28.2911 21.471 28.2289 21.6503 28.1345 21.8137C28.0424 21.9731 27.9219 22.1133 27.7797 22.228C27.6381 22.3744 27.4763 22.501 27.2985 22.6036L19.6008 27.0023C19.4126 27.111 19.2102 27.1907 19.0003 27.2396C18.8407 27.2964 18.6719 27.3257 18.5011 27.3257C18.3303 27.3257 18.1615 27.2964 18.0019 27.2396C17.792 27.1907 17.5896 27.111 17.4014 27.0023L9.70371 22.6036C9.52589 22.501 9.3641 22.3744 9.22255 22.228C9.08031 22.1133 8.95985 21.9731 8.86775 21.8137C8.77329 21.6503 8.71107 21.471 8.68371 21.2856C8.63126 21.096 8.60424 20.8995 8.60404 20.7012V11.9038C8.60424 11.7051 8.63135 11.5083 8.68396 11.3185C8.71145 11.1337 8.77358 10.955 8.86775 10.792C8.9591 10.634 9.07836 10.4947 9.21911 10.3805C9.36147 10.2327 9.52444 10.1049 9.70371 10.0014L17.4014 5.60266C17.5915 5.4929 17.7962 5.41269 18.0083 5.36392Z"
      fill="black"
    />
    <path
      d="M22.8689 1.25586C15.9675 5.27617 2.12548 13.3498 1.96777 13.4812L13.0229 19.6019L33.9678 7.61064L22.8689 1.25586Z"
      fill="white"
      stroke="black"
      strokeWidth="2"
      strokeLinejoin="round"
    />
    <path
      d="M18.5066 4.16426L29.2275 10.3613"
      stroke="black"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.7859 10.1057L18.5068 16.3027"
      stroke="black"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ClosedPackageIcon: React.FC<{ className?: string }> = ({ className }) => (
  <svg
    className={className}
    data-testid="closed-package-icon"
    width="28"
    height="28"
    viewBox="-2 0 35 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M22 12.6251L10 5.70508" stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    <path
      d="M28 21.4257V10.759C27.9995 10.2913 27.8761 9.83206 27.6421 9.4272C27.408 9.02234 27.0717 8.68613 26.6667 8.45232L17.3333 3.11898C16.9279 2.88494 16.4681 2.76172 16 2.76172C15.5319 2.76172 15.0721 2.88494 14.6667 3.11898L5.33333 8.45232C4.92835 8.68613 4.59197 9.02234 4.35795 9.4272C4.12392 9.83206 4.00048 10.2913 4 10.759V21.4257C4.00048 21.8933 4.12392 22.3526 4.35795 22.7574C4.59197 23.1623 4.92835 23.4985 5.33333 23.7323L14.6667 29.0656C15.0721 29.2997 15.5319 29.4229 16 29.4229C16.4681 29.4229 16.9279 29.2997 17.3333 29.0656L26.6667 23.7323C27.0717 23.4985 27.408 23.1623 27.6421 22.7574C27.8761 22.3526 27.9995 21.8933 28 21.4257Z"
      stroke="black"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.36035 9.37109L16.0004 16.1044L27.6404 9.37109"
      stroke="black"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M16 29.5318V16.0918" stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export default PackageIcon;
